import React, {Fragment, MouseEvent} from 'react';
import {EfeButtonSecondary, EfeModal} from 'components';
import {Box, Typography} from '@material-ui/core';
import EfeModalMsg from 'components/efe-modal-msg/EfeModalMsg';

const error: any = {
    data: {
        errors: ['Asignación de rol incorrecta', 'RFC ya ha sido registrado'],
        message: 'Error en la validación',
        process: 'Validación de rol',
        httpStatus: 'CONFLICT',
    },
    success: false,
    code: 409,
    status: 'Error',
    message: 'Request failed with status code 409',
};

function Modal() {
    const [open, setOpen] = React.useState<boolean>(false);
    const [showAlert, setShowAlert] = React.useState<boolean>(false);
    const [open2, setOpen2] = React.useState<boolean>(false);

    const handleOpenClose = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        setOpen((prevState) => !prevState);
    };

    function onAction(action: string) {
        setOpen((prevState) => !prevState);
    }

    function callAlert() {
        setOpen2(!open2);
        setShowAlert(open2);
    }
    const element = (
        <Typography variant='body2' paragraph>
            {
                'De confirmar esta acci\u00f3n enviaremos una notificaci\u00f3n a tu empresa para dar seguimiento a la solicitud.'
            }
        </Typography>
    );

    return (
        <Fragment>
            <Box pt={4}>
                <EfeButtonSecondary type='button' onClick={handleOpenClose}>
                    {'Show Modal'}
                </EfeButtonSecondary>
            </Box>
            <Box pt={4}>
                <EfeButtonSecondary type='button' onClick={callAlert}>
                    {'Show Alert'}
                </EfeButtonSecondary>
            </Box>
            <Box pt={4}>
                <EfeModal
                    open={open}
                    title={'\u00bfDeseas cancelar tu tarjeta?'}
                    //disabled={false}
                    reactElement={element}
                    info={
                        'Si tienes alguna duda o problema te sugerimos comunicarte al n\u00famero 5555 5555 para atenderte.'
                    }
                    actions={['accept', 'decline']}
                    handleAction={onAction}
                />
                {showAlert && (
                    <EfeModalMsg
                        error={error}
                        open={showAlert}
                        defaultError='Error por default'
                        handleAction={callAlert}
                    />
                )}
            </Box>
        </Fragment>
    );
}
export default Modal;
